module.exports = __webpack_public_path__ + "static/img/TCL华星印刷OLED.4999c677.png";